import { TerminatedEmployeeInput } from '../types';

export const createEmptyEmployee = (): TerminatedEmployeeInput => ({
  socialSecurityNumber: '',
  firstName: '',
  lastName: '',
  employmentType: '',
  startDate: '',
  terminationDate: '',
  endDate: '',
  email: '',
  phone: '',
});
